// extracted by mini-css-extract-plugin
export var phone = "_40-0";